import React, { PropTypes } from 'react';

const style = {
  textAlign: 'center',
  fontSize: 18,
  color: '#ff0000',
  backgroundColor: '#ffff00',
  padding: 10,
  border: 'solid',
};

const ErrorMessage = ({ message }) => <div style={style}>{message}</div>;

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/components/ErrorMessage.js